import React from 'react';
import { classnames } from 'helpers/utils';
import { CrossIcon } from 'assets/icons';
import styles from './badge.module.scss';

type BadgeProps = {
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  message?: string;
  className?: string;
  closable?: boolean;
  onPressClose?: () => void;
};

const Badge: React.FC<BadgeProps> = ({
  icon,
  iconPosition = 'left',
  message,
  className = '',
  closable = false,
  onPressClose,
}) => {
  const classes = classnames(...[className, styles.badge]);
  return (
    <div className={classnames(classes, 'text__body__bold__tiny__gray700')}>
      {iconPosition === 'left' && icon} {message && <p>{message}</p>}
      {closable && (
        <button
          type="button"
          className={styles.closeButton}
          onClick={onPressClose}
        >
          <CrossIcon />
        </button>
      )}
      {iconPosition === 'right' && icon}
    </div>
  );
};

export { Badge };
